// #256: Diagnosedaten zum Service Worker für den Feedback-Knopf.
//
// Warum: Meldungen wie "Dashboard beim ersten Laden unvollständig" waren bisher
// nicht auswertbar, weil aus dem Feedback nicht hervorging, welcher Service
// Worker auf dem meldenden Gerät aktiv war und ob die Anzeige überhaupt aus
// dem Cache kam. Die Checkliste in #256 musste deshalb jedes Mal am Arbeitsplatz
// per DevTools durchgegangen werden — und war dort meist schon nicht mehr
// reproduzierbar. Diese Angaben hängen jetzt automatisch am Feedback.
//
// Erfasst wird ausschließlich Technik (Worker-Zustand, Cache-Namen, Pfade der
// gestörten Aufrufe) — keine Inhalte aus Antworten.

const MAX_EVENTS = 10;
const degradedEvents = [];

function pfadVon(url) {
  if (!url) return null;
  try {
    return new URL(String(url), window.location.origin).pathname;
  } catch (_) {
    return String(url).split('?')[0];
  }
}

function merken(event) {
  try {
    degradedEvents.push({
      kind: event?.detail?.kind || 'unbekannt',
      path: pfadVon(event?.detail?.url),
      cachedAt: event?.detail?.cachedAt || null,
      at: new Date().toISOString()
    });
    while (degradedEvents.length > MAX_EVENTS) degradedEvents.shift();
  } catch (_) {}
}

// Der apiService meldet Cache-Stände und Offline-Fallbacks des Service Workers
// über dieses Event (siehe #229). Wir hoeren unabhaengig vom Toast mit, damit
// auch die Ereignisse erhalten bleiben, die der Nutzer weggeklickt hat.
try {
  if (typeof window !== 'undefined') {
    window.addEventListener('swDegradedResponse', merken);
  }
} catch (_) {}

export async function collectSwDiagnostics() {
  const info = {
    swSupported: false,
    swControlled: false,
    swScriptUrl: null,
    swState: null,
    cacheNames: [],
    online: null,
    degradedEvents: degradedEvents.slice()
  };

  try {
    if (typeof navigator === 'undefined') return info;
    info.online = navigator.onLine !== false;
    info.swSupported = 'serviceWorker' in navigator;

    const controller = info.swSupported ? navigator.serviceWorker.controller : null;
    if (controller) {
      info.swControlled = true;
      info.swScriptUrl = controller.scriptURL || null;
      info.swState = controller.state || null;
    }

    // Die Cache-Namen tragen die Version (shell-v3 / api-swr-v3) und sagen
    // damit, ob das Gerät den aktuellen Worker angenommen hat.
    if (typeof caches !== 'undefined' && caches.keys) {
      info.cacheNames = await caches.keys();
    }
  } catch (_) {}

  return info;
}

export default collectSwDiagnostics;
